export { WatermarkLogo, WatermarkPercent } from './Watermarks';
export { Watermark, type WatermarkType, type WatermarkProps } from './Watermark';
export { default } from './Watermark';
